
import { Component, Vue, Prop } from "vue-property-decorator";
import { NoticeVO } from "@/views/biz/mypage/vo/mypage.vo";
import { DateTime } from "luxon";
import axios from "axios";

@Component
export default class Notice extends Vue {
  @Prop() noticeCd!: string;
  // 공지목록
  notice: NoticeVO = {} as NoticeVO;

  created(): void {
    axios.get("/notice", { params: { noticeCd: this.noticeCd } }).then((r) => {
      this.notice = r.data;
      this.notice.updDate = DateTime.fromSQL(this.notice.updDate).toFormat("yyyy-MM-dd HH:mm:ss");
    });
  }
}
